import * as moment from "moment";
import { Moment } from "moment";

export class InvoicePaymentModel {
    Id: number = 0;
    InvoiceId: number = 0;
    Amount: number = 0;
    Method: string = null;
    // DateCreated: string = moment().format("DD/MM/yyyy");
    DateCreated: Date;

    constructor() {
    }
}